import React from 'react';
import '../../styles/dashboard/TweetCard.css';

function TweetCard({ tweet }) {
  const formatNumber = (num) => {
    if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
    if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
    return num;
  };

  return (
    <div className="tweet-card">
      {/* Header */}
      <div className="tweet-header">
        <img 
          src={tweet.author.image} 
          alt={tweet.author.name}
          className="tweet-avatar"
        />
        <div className="tweet-author-info">
          <h3 className="tweet-author-name">{tweet.author.name}</h3>
          <p className="tweet-author-username">@{tweet.author.username}</p>
        </div>
      </div>

      {/* Content */}
      <div className="tweet-content">
        <p>{tweet.text}</p>
      </div>

      {/* Metrics */}
      <div className="tweet-metrics">
        <div className="metric">
          <span className="metric-icon">💬</span>
          <span className="metric-value">{formatNumber(tweet.metrics.replies)}</span>
        </div>
        <div className="metric">
          <span className="metric-icon">🔄</span>
          <span className="metric-value">{formatNumber(tweet.metrics.retweets)}</span>
        </div>
        <div className="metric">
          <span className="metric-icon">❤️</span>
          <span className="metric-value">{formatNumber(tweet.metrics.likes)}</span>
        </div>
      </div>

      {/* Actions */}
<div className="tweet-actions">
  <a 
    href={tweet.url}
    target="_blank"
    rel="noopener noreferrer"
    className="tweet-btn"
  >
    🔗 פתח בטוויטר
  </a>
</div>
    </div>
  );
}

export default TweetCard;